import React, { useEffect, useState } from 'react';
import AdminLayout from 'components/layout/AdminLayout';
import Header from 'components/layout/Partials/Header';
import Loading from 'components/common/Loading';
import Section from 'components/UI/Section';
import { Box } from '@material-ui/core';
import MoreActionsMenu from 'components/settings/Users/Partials/MoreActionsMenu';
import UserEditForm from 'components/settings/Users/Edit/UserEditForm';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from 'redux/auth/selectors';
import { useParams } from 'react-router-dom';
import api from 'api';
import { ToastsStore } from 'react-toasts';
import { hideDialog, showDialog } from 'redux/alerts/actions';
import ReAuthenticationForm from 'components/settings/Users/Edit/ReAuthenticationForm';
import { generateUserEditKeys } from 'components/settings/Users/Edit/util';
import config from 'coeus.config';
import { qlikClient } from 'constants/environmental';

const SAAS = config.saas_client === qlikClient.SAAS;

const keys = generateUserEditKeys();
const EditUser = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const { user: loggedInUser } = useSelector(authSelector);
    const [initialValues, setInitialValues] = useState(null);
    const dispatch = useDispatch();

    const loadUser = () => {
        api.users
            .getProfile(id)
            .then((results) => {
                setInitialValues(createInitialValues(results, keys));
            })
            .catch((err) => {
                setLoading(false);
                ToastsStore.error('Error loading user');
                console.error(err);
            });
    };

    const closeDialog = () => {
        dispatch(hideDialog());
    };

    const reAuthDialog = (data) => {
        dispatch(
            showDialog({
                open: true,
                content: (
                    <ReAuthenticationForm
                        updateUser={updateUser}
                        initialValues={{ ...data, password: '' }}
                    />
                ),
                handleClose: closeDialog,
            })
        );
    };

    const updateUser = (data) => {
        api.users
            .update(id, data)
            .then(() => {
                closeDialog();
                ToastsStore.success('User Saved Successfully');
            })
            .catch((err) => {
                ToastsStore.error('Error: Failed to Update User');
                console.error(err);
            });
    };

    const changePasswordRequest = () => {
        const { name, email: mailTo } = initialValues;
        const data = {
            name,
            userId: id,
            mailTo,
        };

        api.users
            .changePasswordEmail(data)
            .then((results) => {
                ToastsStore.success('Request Successfully Sent');
                console.log(results);
            })
            .catch((err) => {
                ToastsStore.error('Failed to send Password Reset');
                console.error(err);
            });
    };

    const createInitialValues = (data, keys) => {
        let object = {};
        keys.forEach((key) => {
            object[key] = data.hasOwnProperty(key) ? data[key] : null;
        });
        return object;
    };

    useEffect(() => {
        if (initialValues) {
            setLoading(false);
        }
    }, [initialValues]);

    useEffect(() => {
        loadUser();
    }, []);

    return (
        <AdminLayout>
            <div className="o-page ">
                <Header>
                    <h2 className="c-navbar__title">Edit User</h2>
                </Header>
                {loading && <Loading />}
                {!loading && (
                    <div className="u-m-xsmall">
                        <Section>
                            <Box className="u-p-small full_heights">
                                <MoreActionsMenu
                                    userId={id}
                                    currentUserId={loggedInUser.id}
                                    changePasswordRequest={
                                        changePasswordRequest
                                    }
                                />
                                <UserEditForm
                                    initialValues={initialValues}
                                    updateUser={
                                        SAAS ? updateUser : reAuthDialog
                                    }
                                />
                            </Box>
                        </Section>
                    </div>
                )}
            </div>
        </AdminLayout>
    );
};

export default EditUser;
